class MediaLoader extends HTMLElement {
  constructor() {
    super()

    this.media = this.querySelector(".media-object")

    this.init()
  }

  init() {
    const { load } = this
    const isLoaded = this.isLoaded()
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    }

    if (!isLoaded) {
      const observer = new IntersectionObserver(load, options)
      observer.observe(this)
    }
  }

  isLoaded() {
    return (this.media.src && this.classList.contains('loaded')) ? true : false
  }

  load(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const timeoutSpeed = 0
        const { target } = entry
        const media = target.querySelector(".media-object")
        const videoTag = target.querySelector('video')
        const { type } = media.dataset

        if (type === "image") {
          const { src, srcset } = media.dataset

          if (!media.src && !media.srcset) {
            media.srcset = srcset
            media.src = src
            media.addEventListener("load", () => {
              setTimeout(() => {
                target.classList.add("loaded")
              }, timeoutSpeed)
            })
            observer.disconnect()
          } else if (media.src && media.srcset) {
            target.classList.add("loaded")
          }
        } else if (type === "video") {
          const { src } = media.dataset

          media.src = src
          videoTag.load()
          media.addEventListener("load", () => {
            setTimeout(() => {
              target.classList.add("loaded")
            }, timeoutSpeed)
          })
          observer.disconnect()
        }
      }
    })
  }
}

customElements.define("media-loader", MediaLoader)
